module.exports = __webpack_public_path__ + "static/media/batman-static.73c30636.png";